/**
 * @description router全局配置，如有必要可分文件抽离，其中asyncRoutes只有在intelligence模式下才会用到，pro版只支持remixIcon图标，具体配置请查看vip群文档
 */
import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'
import Layout from '@/vab/layouts'
/* 多级路由不需要缓存时可放开注释直接引入 用法component:VabEmptyLayout*/
/* import VabEmptyLayout from '@/vab/layouts/VabEmptyLayout' */
import {
  getNames
} from '@/utils/routes'
import {
  isHashRouterMode,
  publicPath
} from '@/config'

export const constantRoutes = [{
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login'),
  hidden: true,
},
{
  path: '/register',
  name: 'Register',
  component: () => import('@/views/register'),
  hidden: true,
},
{
  path: '/403',
  name: '403',
  component: () => import('@/views/403'),
  hidden: true,
},
{
  path: '/404',
  name: '404',
  component: () => import('@/views/404'),
  hidden: true,
},
]

export const asyncRoutes = [
    // OA
    {
      path: '/oa',
      name: 'Oa',
      component: Layout,
      redirect: '/oa/car',
      hidden: true,
      meta: {
        title: '流程单',
        icon: 'hotel-fill',
      },
      children: [
        {
          path: 'car',
          name: 'OaCarIndex',
          component: () => import('@/views/oa/car'),
          meta: {
            title: '车辆',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'carRecord',
          name: 'OaCarRecord',
          component: () => import('@/views/oa/carRecord'),
          meta: {
            title: '车辆出场记录',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'peopleRecord',
          name: 'OaPeopleRecordIndex',
          component: () => import('@/views/oa/peopleRecord'),
          meta: {
            title: '人员出场记录',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },{
          path: 'patrolRecord',
          name: 'OaPatrolRecordIndex',
          component: () => import('@/views/oa/patrolRecord'),
          meta: {
            title: '巡查记录',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },{
          path: 'visitorRecord',
          name: 'OaVisitorRecordIndex',
          component: () => import('@/views/oa/visitorRecord'),
          meta: {
            title: '访客登记记录',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'calendar',
          name: 'calendarIndex',
          component: () => import('@/views/oa/calendar'),
          meta: {
            title: '人员请假日历',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'vacation',
          name: 'vacationIndex',
          component: () => import('@/views/oa/vacation'),
          meta: {
            title: '人员请假天数',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'setupConfig',
          name: 'OaSetupConfig',
          component: () => import('@/views/oa/setupConfig'),
          meta: {
            title: '设置安全提醒',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        }
      ]
    },
    //协议公司
    {
      path: '/agreementCompany',
      name: 'AgreementCompany',
      component: Layout,
      redirect: '/agreementCompany/company',
      hidden: true,
      meta: {
        title: '协议公司',
        icon: 'hotel-fill',
      },
      children: [
        {
          path: 'company',
          name: 'CompanyIndex',
          component: () => import('@/views/agreementCompany/company'),
          meta: {
            title: '协议客户',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'agreementPeopleIndex',
          name: 'AgreementPeopleIndex',
          component: () => import('@/views/agreementCompany/people'),
          meta: {
            title: '订房人',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        }
      ]
    },
    //客房
    {
      path: '/room',
      name: 'room',
      component: Layout,
      redirect: '/room/hotel',
      hidden: true,
      meta: {
        title: '客房',
        icon: 'hotel-fill',
      },
      children: [
        {
          path: 'hotel',
          name: 'Hotel',
          component: () => import('@/views/room/hotel'),
          meta: {
            title: '酒店',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'roomType',
          name: 'RoomType',
          component: () => import('@/views/room/roomType'),
          meta: {
            title: '房型设置',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'roomPriceCode',
          name: 'RoomPriceCode',
          component: () => import('@/views/room/roomPriceCode'),
          meta: {
            title: '房价码设置',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'roomPrice',
          name: 'RoomPrice',
          component: () => import('@/views/room/roomPrice'),
          meta: {
            title: '房价设置',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        },
        {
          path: 'roomCount',
          name: 'RoomCount',
          component: () => import('@/views/room/roomCount'),
          meta: {
            title: '房量设置',
            icon: 'hotel-bed-line',
            noCLosable: true
          },
        }
      ]
    },
    //棋牌室
    {
      path: '/chess',
      name: 'chess',
      component: Layout,
      redirect: '/chess/order',
      hidden: true,
      meta: {
        title: '棋牌室',
        icon: 'home-heart-fill',
      },
      children: [{
        path: 'order',
        name: 'ChessOrder',
        component: () => import('@/views/chess/order'),
        meta: {
          title: '预订订单',
          icon: 'article-line',
          noCLosable: true
        },
      },{
        path: 'room',
        name: 'chessRoom',
        component: () => import('@/views/chess/room'),
        meta: {
          title: '房间',
          icon: 'home-8-line',
          noCLosable: true
        },
      },{
        path: 'tag',
        name: 'chessTag',
        component: () => import('@/views/chess/tag'),
        meta: {
          title: '标签',
          icon: 'hashtag',
          noCLosable: true
        },
      },{
        path: 'section',
        name: 'chessSection',
        component: () => import('@/views/chess/section'),
        meta: {
          title: '预约时段',
          icon: 'time-line',
          noCLosable: true
        },
      },{
        path: 'service',
        name: 'chessService',
        component: () => import('@/views/chess/service'),
        meta: {
          title: '服务项目',
          icon: 'service-line',
          noCLosable: true
        },
      },{
        path: 'manager',
        name: 'chessManager',
        component: () => import('@/views/chess/manager'),
        meta: {
          title: '员工端二维码',
          icon: 'qr-code-line',
          noCLosable: true
        },
      }]
    },
    //艾福迈
    {
      path: '/alfmeier',
      name: 'Alfmeier',
      component: Layout,
      redirect: '/alfmeier/profile',
      hidden: true,
      meta: {
        title: '艾福迈',
        icon: 'price-tag-2-line',
      },
      children: [{
        path: 'profile',
        name: 'AlfmeierProfile',
        component: () => import('@/views/alfmeier/profile/list'),
        meta: {
          title: '用户记录',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'rankRecordList',
        name: 'AlfmeierRankRecordList',
        component: () => import('@/views/alfmeier/rank/recordList'),
        meta: {
          title: '评价记录',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'paymentRecordList',
        name: 'AlfmeierPaymentRecordList',
        component: () => import('@/views/alfmeier/payment/recordList'),
        meta: {
          title: '支付记录',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'questRecordList',
        name: 'AlfmeierQuestRecordList',
        component: () => import('@/views/alfmeier/quest/recordList'),
        meta: {
          title: '问卷回复记录',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'advertiseRecordList',
        name: 'AlfmeierAdvertiseRecordList',
        component: () => import('@/views/alfmeier/advertise/recordList'),
        meta: {
          title: '广告观看记录',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'deviceRecordList',
        name: 'AlfmeierDeviceRecordList',
        component: () => import('@/views/alfmeier/device/recordList'),
        meta: {
          title: '设备使用记录',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'rankList',
        name: 'AlfmeierRankList',
        component: () => import('@/views/alfmeier/rank/list'),
        meta: {
          title: '评价设置',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'paymentList',
        name: 'AlfmeierPaymentList',
        component: () => import('@/views/alfmeier/payment/list'),
        meta: {
          title: '支付设置',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'questList',
        name: 'AlfmeierQuestList',
        component: () => import('@/views/alfmeier/quest/list'),
        meta: {
          title: '问卷设置',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'advertiseList',
        name: 'AlfmeierAdvertiseList',
        component: () => import('@/views/alfmeier/advertise/list'),
        meta: {
          title: '广告设置',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'deviceList',
        name: 'AlfmeierDeviceList',
        component: () => import('@/views/alfmeier/device/list'),
        meta: {
          title: '设备设置',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },]
    },
    //媒体库
    {
      path: '/mediaLibrary',
      name: 'MediaLibrary',
      component: Layout,
      redirect: '/mediaLibrary/tag',
      hidden: true,
      meta: {
        title: '媒体库',
        icon: 'price-tag-2-line',
      },
      children: [
        {
          path: 'tag',
          name: 'MediaTag',
          component: () => import('@/views/mediaLibrary/tag'),
          meta: {
            title: '标签',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },
        {
          path: 'item',
          name: 'MediaItem',
          component: () => import('@/views/mediaLibrary/item'),
          meta: {
            title: '物件',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },
        {
          path: 'medium',
          name: 'MediaMedium',
          component: () => import('@/views/mediaLibrary/medium'),
          meta: {
            title: '媒体',
            icon: 'image-2-line',
            noCLosable: true
          },
        },
        {
          path: 'setting',
          name: 'MediaSetting',
          component: () => import('@/views/mediaLibrary/setting'),
          meta: {
            title: '设置',
            icon: 'settings-6-line',
            noCLosable: true
          },
        }
      ]
    },
  //餐饮
  {
    path: '/food',
    name: 'Food',
    component: Layout,
    redirect: '/food/restaurant',
    hidden: true,
    meta: {
      title: '餐饮',
      icon: 'cake-3-fill',
    },
    children: [{
      path: 'order',
      name: 'FoodOrder',
      component: () => import('@/views/food/order'),
      meta: {
        title: '订单',
        icon: 'article-line',
        noCLosable: true
      },
    },{
      path: 'restaurant',
      name: 'Restaurant',
      component: () => import('@/views/food/restaurant'),
      meta: {
        title: '餐厅',
        icon: 'cake-3-fill',
        noCLosable: true
      },
    },{
      path: 'dish',
      name: 'FoodDish',
      component: () => import('@/views/food/dish'),
      meta: {
        title: '菜品',
        icon: 'price-tag-2-line',
        noCLosable: true
      },
    },{
      path: 'desk',
      name: 'Desk',
      component: () => import('@/views/food/desk'),
      meta: {
        title: '餐桌',
        icon: 'cup-line',
        noCLosable: true
      },
    },
    {
      path: 'tag',
      name: 'FoodTag',
      component: () => import('@/views/food/tag'),
      meta: {
        title: '菜品标签',
        icon: 'price-tag-2-line',
        noCLosable: true
      },
    }]
  },
  //分账
  {
    path: '/splitAccount',
    name: 'splitAccount',
    component: Layout,
    redirect: '/splitAccount/index',
    hidden: true,
    meta: {
      title: '分账',
      icon: 'bit-coin-line',
    },
    children: [{
      path: 'index',
      name: 'splitAccountIndex',
      component: () => import('@/views/splitAccount'),
      meta: {
        title: '分账方',
        icon: 'bit-coin-line',
        noCLosable: true,
      },
    },{
      path: 'splitRecord',
      name: 'SplitRecord',
      component: () => import('@/views/splitAccount/recordList.vue'),
      meta: {
        title: '分账记录',
        icon: 'bit-coin-line',
        noCLosable: true,
      },
    }]
  },
  {
    path: '/ticket',
    name: 'Ticket',
    component: Layout,
    redirect: '/ticket/index',
    hidden: true,
    meta: {
      title: '门票',
      icon: 'ticket-2-line',
    },
    children: [{
      path: 'index',
      name: 'TicketIndex',
      component: () => import('@/views/ticket/ticket'),
      meta: {
        title: '门票',
        icon: 'ticket-2-line',
        noCLosable: true,
      },
    }, {
      path: 'order',
      name: 'TicketOrder',
      component: () => import('@/views/ticket/order'),
      meta: {
        title: '订单',
        icon: 'ticket-2-line',
        noCLosable: true,
      },
    }, {
      path: 'spot',
      name: 'SpotIndex',
      component: () => import('@/views/ticket/spot'),
      meta: {
        title: '景区',
        icon: 'treasure-map-line',
        noCLosable: true,
      },
    }, {
      path: 'tag',
      name: 'SpotTag',
      component: () => import('@/views/ticket/tag'),
      meta: {
        title: '标签',
        icon: 'price-tag-3-line',
        noCLosable: true,
      },
    }, {
      path: 'faq',
      name: 'SpotFaq',
      component: () => import('@/views/ticket/faq'),
      meta: {
        title: '常见问题',
        icon: 'question-line',
        noCLosable: true,
      },
    }],
  },
  //游戏
  {
    path: '/game',
    name: 'Game',
    component: Layout,
    redirect: '/game/index',
    hidden: true,
    meta: {
      title: '游戏',
      icon: 'gamepad-line',
    },
    children: [{
      path: 'index',
      name: 'GameIndex',
      component: () => import('@/views/game/game'),
      meta: {
        title: '游戏',
        icon: 'gamepad-line',
        noCLosable: true,
      },
    },
    {
      path: 'team',
      name: 'GameTeam',
      component: () => import('@/views/game/team'),
      meta: {
        title: '战队',
        icon: 'team-line',
        noCLosable: true,
      },
    }, {
      path: 'task',
      name: 'GameTask',
      component: () => import('@/views/game/task'),
      meta: {
        title: '任务',
        icon: 'task-line',
        noCLosable: true,
      },
    }, {
      path: 'gift',
      name: 'GameGift',
      component: () => import('@/views/game/gift'),
      meta: {
        title: '礼品',
        icon: 'gift-2-line',
        noCLosable: true,
      },
    }, {
      path: 'giftRecord',
      name: 'GiftRecord',
      component: () => import('@/views/game/giftRecord'),
      meta: {
        title: '中奖记录',
        icon: 'gift-2-line',
        noCLosable: true,
      },
    },
    {
      path: 'peopleRank',
      name: 'PeopleRank',
      component: () => import('@/views/game/peopleRank'),
      meta: {
        title: '玩家排行',
        icon: 'award-line',
        noCLosable: true,
      },
    },
    {
      path: 'teamRank',
      name: 'TeamRank',
      component: () => import('@/views/game/teamRank'),
      meta: {
        title: '战队排行',
        icon: 'award-line',
        noCLosable: true,
      },
    }, {
      path: 'scoreDetail',
      name: 'ScoreDetail',
      component: () => import('@/views/game/scoreDetail'),
      meta: {
        title: '积分明细',
        icon: 'article-line',
        noCLosable: true,
      },
    }],
  },
  // 财务
  {
    path: '/finance',
    name: 'Finance',
    component: Layout,
    redirect: '/finance/income',
    hidden: true,
    meta: {
      title: '财务',
      icon: 'money-cny-circle-line',
    },
    children: [{
      path: 'income',
      name: 'Income',
      component: () => import('@/views/finance/income'),
      meta: {
        title: '线上收款明细',
        icon: 'money-euro-circle-line',
        noCLosable: true,
      },
    }, {
      path: 'refund',
      name: 'Refund',
      component: () => import('@/views/finance/refund'),
      meta: {
        title: '线上退款明细',
        icon: 'money-euro-circle-line',
        noCLosable: true,
      },
    }],
  },
  // 商城
  {
    path: '/shop',
    name: 'Shop',
    component: Layout,
    redirect: '/shop/product',
    hidden: true,
    meta: {
      title: '商城',
      icon: 'shopping-bag-3-line',
    },
    children: [{
      path: 'product',
      name: 'Product',
      component: () => import('@/views/widget/shop/product'),
      meta: {
        title: '商品',
        icon: 'shopping-bag-line',
        noCLosable: true,
      },
    }, {
      path: 'tag',
      name: 'Tag',
      component: () => import('@/views/widget/shop/tag'),
      meta: {
        title: '商品标签',
        icon: 'price-tag-3-line',
        noCLosable: true,
      },
    }, {
      path: 'shopCarousel',
      name: 'ShopCarousel',
      component: () => import('@/views/widget/shop/carousel'),
      meta: {
        title: '轮播图',
        icon: 'image-2-fill',
        noCLosable: true,
      },
    }, {
      path: 'tiktok',
      name: 'Tiktok',
      component: () => import('@/views/widget/shop/tiktok'),
      meta: {
        title: '抖音落地页',
        icon: 'disc-line',
        noCLosable: true,
      },
    },],
  },
  {
    path: '/people',
    name: 'People',
    component: Layout,
    redirect: '/people/index',
    hidden: true,
    meta: {
      title: '用户',
      icon: 'user-3-line',
    },
    children: [{
      path: 'index',
      name: 'PeopleIndex',
      component: () => import('@/views/people/people'),
      meta: {
        title: '首页',
        icon: 'file-search-line',
        noCLosable: true,
        collapse: true,
      },
    },],
  },
  
  {
    path: '/display',
    name: 'Display',
    component: Layout,
    redirect: '/display/wechatQrCode',
    meta: {
      title: '展示',
      icon: 'landscape-line',
    },
    hidden: true,
    children: [
      {
        path: 'wechatQrCode',
        name: 'WechatQrCode',
        component: () => import('@/views/widget/wechatQrCode'),
        meta: {
          title: '微信小程序码',
          icon: 'qr-code-line',
          noCLosable: true,
          type: 'wechatCode',
          classify: 'display'
        },
      },
      {
        path: 'carousel',
        name: 'Carousel',
        component: () => import('@/views/widget/carousel'),
        meta: {
          title: '轮播图',
          icon: 'image-2-fill',
          noCLosable: true,
          type: 'carousel',
          classify: 'display'
        },
      },
      {
        path: 'banner',
        name: 'Banner',
        component: () => import('@/views/widget/banner'),
        meta: {
          title: '横幅',
          icon: 'image-line',
          noCLosable: true,
          type: 'banner',
          classify: 'display'
        },
      },
      {
        path: 'article',
        name: 'Article',
        component: () => import('@/views/widget/article'),
        meta: {
          title: '文章',
          icon: 'file-word-line',
          noCLosable: true,
          type: 'article',
          classify: 'display'
        },
      },
      {
        path: 'landing',
        name: 'Landing',
        component: () => import('@/views/widget/landing'),
        meta: {
          title: '落地页',
          icon: 'file-word-line',
          noCLosable: true,
          type: 'landing',
          classify: 'display'
        },
      },
    ],
  },
  {
    path: '/stay',
    name: 'Stay',
    component: Layout,
    redirect: '/stay/record',
    meta: {
      title: '入住',
      icon: 'record-circle-line',
    },
    hidden: true,
    children: [
      {
        path: 'record',
        name: 'Record',
        component: () => import('@/views/stay/record'),
        meta: {
          title: '入住记录',
          icon: 'calendar-check-line',
          noCLosable: true,
        },
      },
      {
        path: 'receiver',
        name: 'Receiver',
        component: () => import('@/views/stay/receiver'),
        meta: {
          title: '接收人',
          icon: 'cellphone-line',
          noCLosable: true,
        },
      },
    ],
  },
  // 公寓
  {
    path: '/apartment',
    name: 'Apartment',
    component: Layout,
    redirect: '/apartment/apartmentOrder',
    meta: {
      title: '公寓',
      icon: 'home-4-line',
    },
    hidden: true,
    children: [
      {
        path: 'apartmentOrder',
        name: 'ApartmentOrder',
        component: () => import('@/views/order/apartment'),
        meta: {
          title: '订单',
          icon: 'hotel-line',
          noCLosable: true,
        },
      },
      {
        path: 'building',
        name: 'Building',
        component: () => import('@/views/apartment/building'),
        meta: {
          title: '公寓',
          icon: 'hotel-line',
          noCLosable: true,
        },
      },
      {
        path: 'room',
        name: 'Room',
        component: () => import('@/views/apartment/room'),
        meta: {
          title: '房型',
          icon: 'hotel-bed-line',
          noCLosable: true,
        },
      },
      {
        path: 'dynamic',
        name: 'Dynamic',
        component: () => import('@/views/apartment/dynamic'),
        meta: {
          title: '动态',
          icon: 'chrome-line',
          noCLosable: true,
        },
      },
      {
        path: 'province',
        name: 'Province',
        component: () => import('@/views/apartment/province'),
        meta: {
          title: '州',
          icon: 'map-pin-add-line',
          noCLosable: true,
        },
      },
      {
        path: 'city',
        name: 'City',
        component: () => import('@/views/apartment/city'),
        meta: {
          title: '街区',
          icon: 'map-pin-add-line',
          noCLosable: true,
        },
      },
      {
        path: 'setup',
        name: 'Setup',
        component: () => import('@/views/apartment/setup'),
        meta: {
          title: '配置',
          icon: 'settings-4-line',
          noCLosable: true,
        },
      },

    ],
  },
  {
    path: '/customer',
    name: 'Customer',
    component: Layout,
    redirect: '/customer/chat',
    meta: {
      title: '客服',
      icon: 'customer-service-line',
    },
    hidden: true,
    children: [
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/views/customer/chat'),
        meta: {
          title: '会话',
          icon: 'chat-1-line',
          noCLosable: true,
        },
      },
      {
        path: 'history',
        name: 'ChatHistory',
        component: () => import('@/views/customer/history'),
        meta: {
          title: '历史会话',
          icon: 'chat-history-line',
          noCLosable: true,
        },
      },
      {
        path: 'servicePeople',
        name: 'ServicePeople',
        component: () => import('@/views/customer/people'),
        meta: {
          title: '客服人员',
          icon: 'customer-service-2-line',
          noCLosable: true,
        },
      },
    ],
  },
  {
    path: '/operation',
    name: 'Operation',
    component: Layout,
    redirect: '/operation/log',
    meta: {
      title: '运维',
      icon: 'tools-line',
    },
    hidden: true,
    children: [
      {
        path: 'log',
        name: 'Log',
        component: () => import('@/views/operation/log'),
        meta: {
          title: '操作日志',
          icon: 'list-settings-line',
          noCLosable: true,
        },
      },
      {
        path: 'person',
        name: 'Person',
        component: () => import('@/views/operation/person'),
        meta: {
          title: '运维人员',
          icon: 'user-settings-line',
          noCLosable: true,
        },
      },
    ],
  },
  {
    path: '/order',
    name: 'Order',
    component: Layout,
    redirect: '/order/list',
    meta: {
      title: '订单',
      icon: 'file-list-line',
    },
    hidden: true,
    children: [
      {
        path: 'list',
        name: 'List',
        component: () => import('@/views/order/list'),
        meta: {
          title: '所有订单',
          icon: 'list-check-2',
          noCLosable: true,
          type: 'all',
          classify: 'order'
        },
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/order/products'),
        meta: {
          title: '商品订单',
          icon: 'luggage-cart-line',
          noCLosable: true,
          type: 'products',
          classify: 'order'
        },
      },

    ],
  },
  {
    path: '/notification',
    name: 'Notification',
    component: Layout,
    redirect: '/notification/message',
    meta: {
      title: '通知',
      icon: 'notification-line',
    },
    hidden: true,
    children: [
      {
        path: 'message',
        name: 'Message',
        component: () => import('@/views/notification/message'),
        meta: {
          title: '短信发送记录',
          icon: 'message-3-line',
          noCLosable: true,
        },
      },
    ],
  },
  {
    path: '/questionRegForm',
    name: 'QuestionRegForm',
    component: Layout,
    redirect: '/questionRegForm/index',
    meta: {
      title: '问卷表',
      icon: 'file-list-3-line',
      isHide: true
    },
    hidden: true,
    children: [{
      path: 'index',
      name: 'QuestionRegFormIndex',
      component: () => import('@/views/widget/questionRegForm'),
      meta: {
        title: '问卷表',
        icon: 'article-line',
        noCLosable: true,
        collapse: true,
      },
    },]
  },
  {
    path: '/',
    name: 'Root',
    component: Layout,
    redirect: '/widget',
    meta: {
      title: '工作台',
      icon: 'apps-line',
    },
    children: [{
      path: 'widget',
      name: 'Widget',
      component: () => import('@/views/widget/list'),
      meta: {
        title: '功能查询',
        icon: 'file-search-line',
        noCLosable: true,
        collapse: true
      },
    }],
  },
  {
    path: '/branch',
    name: 'Branch',
    component: Layout,
    redirect: '/branch/staff',
    hidden: false,
    meta: {
      title: '组织',
      icon: 'building-2-line',
    },
    children: [{
      path: 'staff',
      name: 'BranchStaff',
      component: () => import('@/views/branch/staff'),
      meta: {
        title: '员工',
        icon: 'user-6-line',
        noCLosable: true,
      },
    },
    {
      path: 'department',
      name: 'BranchDepartment',
      component: () => import('@/views/branch/department'),
      meta: {
        title: '部门',
        icon: 'account-box-line',
        noCLosable: true,
      },
    },
    {
      path: 'branch',
      name: 'BranchBranch',
      component: () => import('@/views/branch/branch'),
      meta: {
        title: '门店',
        icon: 'building-line',
        noCLosable: true,
      },
    },
    {
      path: 'industry',
      name: 'BranchIndustry',
      component: () => import('@/views/branch/industry'),
      meta: {
        title: '业态',
        icon: 'ancient-pavilion-line',
        noCLosable: true,
      },
    },
    ],
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Layout,
    redirect: '/settings/index',
    hidden: false,
    meta: {
      title: '设置',
      icon: 'settings-4-line',
    },
    children: [{
      path: 'index',
      name: 'SettingsIndex',
      component: () => import('@/views/settings/index'),
      meta: {
        title: '首页',
        icon: 'settings-6-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'basic',
      name: 'SettingsBasic',
      component: () => import('@/views/settings/basic'),
      meta: {
        title: '基本信息',
        icon: 'settings-6-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'bangqi',
      name: 'SettingsBangqi',
      component: () => import('@/views/settings/bangqi'),
      meta: {
        title: '邦奇',
        icon: 'settings-6-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'bangwei',
      name: 'SettingsBangwei',
      component: () => import('@/views/settings/bangwei'),
      meta: {
        title: '邦威客控',
        icon: 'settings-6-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'xiruan',
      name: 'SettingsXiruan',
      component: () => import('@/views/settings/xiruan'),
      meta: {
        title: '西软XCS',
        icon: 'settings-6-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'saiyou',
      name: 'SettingsSaiYou',
      component: () => import('@/views/settings/saiyou'),
      meta: {
        title: '赛邮',
        icon: 'settings-6-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'doudian',
      name: 'SettingsDouDian',
      component: () => import('@/views/settings/doudian'),
      meta: {
        title: '抖店',
        icon: 'settings-6-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'weapp',
      name: 'SettingsWeApp',
      component: () => import('@/views/settings/weapp'),
      meta: {
        title: '微信小程序',
        icon: 'wechat-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'wewap',
      name: 'SettingsWeWap',
      component: () => import('@/views/settings/wewap'),
      meta: {
        title: '微信公众号',
        icon: 'wechat-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'wePay',
      name: 'SettingsWePay',
      component: () => import('@/views/settings/wePay'),
      meta: {
        title: '微信支付',
        icon: 'wechat-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'openApiKey',
      name: 'SettingsOpenApiKey',
      component: () => import('@/views/settings/openApiKey'),
      meta: {
        title: 'OpenApiKey',
        icon: 'wechat-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'guanjiapo',
      name: 'GuanJiaPo',
      component: () => import('@/views/settings/guanjiapo'),
      meta: {
        title: '管家婆',
        icon: 'hand-coin-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'express100',
      name: 'Express100',
      component: () => import('@/views/settings/express100'),
      meta: {
        title: '快递100',
        icon: 'caravan-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'printer',
      name: 'SettingsPrinter',
      component: () => import('@/views/settings/printer'),
      meta: {
        title: '打印机',
        icon: 'printer-line',
        noCLosable: true,
        collapse: true
      },
    },
    {
      path: 'qiniu',
      name: 'SettingsQiniu',
      component: () => import('@/views/settings/qiniu'),
      meta: {
        title: '七牛云',
        icon: 'cloud-line',
        noCLosable: true,
        collapse: true
      },
    },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    name: 'NotFound',
    hidden: true,
  },
  {
    path: '/model',
    name: 'Model',
    component: Layout,
    redirect: '/model/index',
    hidden: true,
    meta: {
      title: 'model',
      icon: 'user-3-line',
    },
    children: [{
      path: 'index',
      name: 'index',
      component: () => import('@/views/modelSetting/index'),
      meta: {
        title: 'index',
        icon: 'file-search-line',
        noCLosable: true,
        collapse: true,
      },
    },
    {
      path: 'model',
      name: 'Model',
      component: () => import('@/views/modelSetting/model/index'),
      meta: {
        title: 'model',
        icon: 'file-search-line',
        noCLosable: true,
        collapse: true,
      },
    },{
      path: 'modelInstance',
      name: 'ModelInstance',
      component: () => import('@/views/modelSetting/modelInstance/index'),
      meta: {
        title: 'model实例',
        icon: 'hotel-bed-line',
        noCLosable: true
      },
    },],
  },
]
export const appRoutes = [
  // OA
  {
    path: '/oa',
    name: 'Oa',
    component: Layout,
    redirect: '/oa/car',
    hidden: true,
    meta: {
      title: '流程单',
      icon: 'hotel-fill',
    },
    children: [
      {
        path: 'car',
        name: 'OaCarIndex',
        component: () => import('@/views/oa/car'),
        meta: {
          title: '车辆',
          icon: 'hotel-bed-line',
          noCLosable: true
        },
      },
      {
        path: 'car',
        name: 'OaCarRecord',
        component: () => import('@/views/oa/carRecord'),
        meta: {
          title: '车辆出场记录',
          icon: 'hotel-bed-line',
          noCLosable: true
        },
      },
      {
        path: 'peopleRecord',
        name: 'OaPeopleRecordIndex',
        component: () => import('@/views/oa/peopleRecord'),
        meta: {
          title: '人员出场记录',
          icon: 'hotel-bed-line',
          noCLosable: true
        },
      }
    ]
  },
      //协议公司
      {
        path: '/agreementCompany',
        name: 'AgreementCompany',
        component: Layout,
        redirect: '/agreementCompany/company',
        hidden: true,
        meta: {
          title: '协议公司',
          icon: 'hotel-fill',
        },
        children: [
          {
            path: 'company',
            name: 'CompanyIndex',
            component: () => import('@/views/agreementCompany/company'),
            meta: {
              title: '协议客户',
              icon: 'hotel-bed-line',
              noCLosable: true
            },
          },
          {
            path: 'agreementPeopleIndex',
            name: 'AgreementPeopleIndex',
            component: () => import('@/views/agreementCompany/people'),
            meta: {
              title: '订房人',
              icon: 'hotel-bed-line',
              noCLosable: true
            },
          }
        ]
      },
      //客房
      {
        path: '/room',
        name: 'room',
        component: Layout,
        redirect: '/room/roomType',
        hidden: true,
        meta: {
          title: '客房',
          icon: 'hotel-fill',
        },
        children: [
          {
            path: 'roomType',
            name: 'RoomType',
            component: () => import('@/views/room/roomType'),
            meta: {
              title: '房型设置',
              icon: 'hotel-bed-line',
              noCLosable: true
            },
          },
          {
            path: 'roomPriceCode',
            name: 'RoomPriceCode',
            component: () => import('@/views/room/roomPriceCode'),
            meta: {
              title: '房价码设置',
              icon: 'hotel-bed-line',
              noCLosable: true
            },
          },
          {
            path: 'roomPrice',
            name: 'RoomPrice',
            component: () => import('@/views/room/roomPrice'),
            meta: {
              title: '房价设置',
              icon: 'hotel-bed-line',
              noCLosable: true
            },
          },
          {
            path: 'roomCount',
            name: 'RoomCount',
            component: () => import('@/views/room/roomCount'),
            meta: {
              title: '房量设置',
              icon: 'hotel-bed-line',
              noCLosable: true
            },
          }
        ]
      },
      //棋牌室
      {
        path: '/chess',
        name: 'chess',
        component: Layout,
        redirect: '/chess/order',
        hidden: true,
        meta: {
          title: '棋牌室',
          icon: 'home-heart-fill',
        },
        children: [{
          path: 'order',
          name: 'ChessOrder',
          component: () => import('@/views/chess/order'),
          meta: {
            title: '预订订单',
            icon: 'article-line',
            noCLosable: true
          },
        },{
          path: 'room',
          name: 'chessRoom',
          component: () => import('@/views/chess/room'),
          meta: {
            title: '房间',
            icon: 'home-8-line',
            noCLosable: true
          },
        },{
          path: 'tag',
          name: 'chessTag',
          component: () => import('@/views/chess/tag'),
          meta: {
            title: '标签',
            icon: 'hashtag',
            noCLosable: true
          },
        },{
          path: 'section',
          name: 'chessSection',
          component: () => import('@/views/chess/section'),
          meta: {
            title: '预约时段',
            icon: 'time-line',
            noCLosable: true
          },
        },{
          path: 'service',
          name: 'chessService',
          component: () => import('@/views/chess/service'),
          meta: {
            title: '服务项目',
            icon: 'service-line',
            noCLosable: true
          },
        },{
          path: 'manager',
          name: 'chessManager',
          component: () => import('@/views/chess/manager'),
          meta: {
            title: '员工端二维码',
            icon: 'qr-code-line',
            noCLosable: true
          },
        }]
      },
      //艾福迈
      {
        path: '/alfmeier',
        name: 'Alfmeier',
        component: Layout,
        redirect: '/alfmeier/profile',
        hidden: true,
        meta: {
          title: '艾福迈',
          icon: 'price-tag-2-line',
        },
        children: [{
          path: 'profile',
          name: 'AlfmeierProfile',
          component: () => import('@/views/alfmeier/profile/list'),
          meta: {
            title: '用户记录',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'rankRecordList',
          name: 'AlfmeierRankRecordList',
          component: () => import('@/views/alfmeier/rank/recordList'),
          meta: {
            title: '评价记录',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'paymentRecordList',
          name: 'AlfmeierPaymentRecordList',
          component: () => import('@/views/alfmeier/payment/recordList'),
          meta: {
            title: '支付记录',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'questRecordList',
          name: 'AlfmeierQuestRecordList',
          component: () => import('@/views/alfmeier/quest/recordList'),
          meta: {
            title: '问卷回复记录',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'advertiseRecordList',
          name: 'AlfmeierAdvertiseRecordList',
          component: () => import('@/views/alfmeier/advertise/recordList'),
          meta: {
            title: '广告观看记录',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'deviceRecordList',
          name: 'AlfmeierDeviceRecordList',
          component: () => import('@/views/alfmeier/device/recordList'),
          meta: {
            title: '设备使用记录',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'rankList',
          name: 'AlfmeierRankList',
          component: () => import('@/views/alfmeier/rank/list'),
          meta: {
            title: '评价设置',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'paymentList',
          name: 'AlfmeierPaymentList',
          component: () => import('@/views/alfmeier/payment/list'),
          meta: {
            title: '支付设置',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'questList',
          name: 'AlfmeierQuestList',
          component: () => import('@/views/alfmeier/quest/list'),
          meta: {
            title: '问卷设置',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'advertiseList',
          name: 'AlfmeierAdvertiseList',
          component: () => import('@/views/alfmeier/advertise/list'),
          meta: {
            title: '广告设置',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },{
          path: 'deviceList',
          name: 'AlfmeierDeviceList',
          component: () => import('@/views/alfmeier/device/list'),
          meta: {
            title: '设备设置',
            icon: 'price-tag-2-line',
            noCLosable: true
          },
        },]
      },
      //媒体库
      {
        path: '/mediaLibrary',
        name: 'MediaLibrary',
        component: Layout,
        redirect: '/mediaLibrary/tag',
        hidden: true,
        meta: {
          title: '媒体库',
          icon: 'price-tag-2-line',
        },
        children: [
          {
            path: 'tag',
            name: 'MediaTag',
            component: () => import('@/views/mediaLibrary/tag'),
            meta: {
              title: '标签',
              icon: 'price-tag-2-line',
              noCLosable: true
            },
          },
          {
            path: 'item',
            name: 'MediaItem',
            component: () => import('@/views/mediaLibrary/item'),
            meta: {
              title: '物件',
              icon: 'price-tag-2-line',
              noCLosable: true
            },
          },
          {
            path: 'medium',
            name: 'MediaMedium',
            component: () => import('@/views/mediaLibrary/medium'),
            meta: {
              title: '媒体',
              icon: 'image-2-line',
              noCLosable: true
            },
          },
          {
            path: 'setting',
            name: 'MediaSetting',
            component: () => import('@/views/mediaLibrary/setting'),
            meta: {
              title: '设置',
              icon: 'settings-6-line',
              noCLosable: true
            },
          }
        ]
      },
    //餐饮
    {
      path: '/food',
      name: 'Food',
      component: Layout,
      redirect: '/food/restaurant',
      hidden: true,
      meta: {
        title: '餐饮',
        icon: 'cake-3-fill',
      },
      children: [{
        path: 'order',
        name: 'FoodOrder',
        component: () => import('@/views/food/order'),
        meta: {
          title: '订单',
          icon: 'article-line',
          noCLosable: true
        },
      },{
        path: 'restaurant',
        name: 'Restaurant',
        component: () => import('@/views/food/restaurant'),
        meta: {
          title: '餐厅',
          icon: 'cake-3-fill',
          noCLosable: true
        },
      },{
        path: 'dish',
        name: 'FoodDish',
        component: () => import('@/views/food/dish'),
        meta: {
          title: '菜品',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      },{
        path: 'desk',
        name: 'Desk',
        component: () => import('@/views/food/desk'),
        meta: {
          title: '餐桌',
          icon: 'cup-line',
          noCLosable: true
        },
      },
      {
        path: 'tag',
        name: 'FoodTag',
        component: () => import('@/views/food/tag'),
        meta: {
          title: '菜品标签',
          icon: 'price-tag-2-line',
          noCLosable: true
        },
      }]
    },
  {
    path: '/splitAccount',
    name: 'splitAccount',
    component: Layout,
    redirect: '/splitAccount/index',
    hidden: true,
    meta: {
      title: '分账',
      icon: 'ticket-2-line',
    },
    children: [{
      path: 'index',
      name: 'splitAccountIndex',
      component: () => import('@/views/splitAccount'),
      meta: {
        title: '分账方',
        icon: 'ticket-2-line',
        noCLosable: true,
      },
    },{
      path: 'splitRecord',
      name: 'SplitRecord',
      component: () => import('@/views/splitAccount/recordList.vue'),
      meta: {
        title: '分账记录',
        icon: 'bit-coin-line',
        noCLosable: true,
      },
    }]
  },
  {
    path: '/ticket',
    name: 'Ticket',
    component: Layout,
    redirect: '/ticket/index',
    hidden: true,
    meta: {
      title: '门票',
      icon: 'ticket-2-line',
    },
    children: [{
      path: 'index',
      name: 'TicketIndex',
      component: () => import('@/views/ticket/ticket'),
      meta: {
        title: '门票',
        icon: 'ticket-2-line',
        noCLosable: true,
      },
    }, {
      path: 'order',
      name: 'TicketOrder',
      component: () => import('@/views/ticket/order'),
      meta: {
        title: '订单',
        icon: 'ticket-2-line',
        noCLosable: true,
      },
    }, {
      path: 'spot',
      name: 'SpotIndex',
      component: () => import('@/views/ticket/spot'),
      meta: {
        title: '景区',
        icon: 'treasure-map-line',
        noCLosable: true,
      },
    }, {
      path: 'tag',
      name: 'SpotTag',
      component: () => import('@/views/ticket/tag'),
      meta: {
        title: '标签',
        icon: 'price-tag-3-line',
        noCLosable: true,
      },
    }, {
      path: 'faq',
      name: 'SpotFaq',
      component: () => import('@/views/ticket/faq'),
      meta: {
        title: '常见问题',
        icon: 'question-line',
        noCLosable: true,
      },
    }],
  },
  //游戏
  {
    path: '/game',
    name: 'Game',
    component: Layout,
    redirect: '/game/index',
    hidden: true,
    meta: {
      title: '游戏',
      icon: 'gamepad-line',
    },
    children: [{
      path: 'index',
      name: 'GameIndex',
      component: () => import('@/views/game/game'),
      meta: {
        title: '游戏',
        icon: 'gamepad-line',
        noCLosable: true,
      },
    },
    {
      path: 'team',
      name: 'GameTeam',
      component: () => import('@/views/game/team'),
      meta: {
        title: '战队',
        icon: 'team-line',
        noCLosable: true,
      },
    }, {
      path: 'task',
      name: 'GameTask',
      component: () => import('@/views/game/task'),
      meta: {
        title: '任务',
        icon: 'task-line',
        noCLosable: true,
      },
    }, {
      path: 'gift',
      name: 'GameGift',
      component: () => import('@/views/game/gift'),
      meta: {
        title: '礼品',
        icon: 'gift-2-line',
        noCLosable: true,
      },
    }, {
      path: 'giftRecord',
      name: 'GiftRecord',
      component: () => import('@/views/game/giftRecord'),
      meta: {
        title: '中奖记录',
        icon: 'gift-2-line',
        noCLosable: true,
      },
    },
    {
      path: 'peopleRank',
      name: 'PeopleRank',
      component: () => import('@/views/game/peopleRank'),
      meta: {
        title: '玩家排行',
        icon: 'award-line',
        noCLosable: true,
      },
    },
    {
      path: 'teamRank',
      name: 'TeamRank',
      component: () => import('@/views/game/teamRank'),
      meta: {
        title: '战队排行',
        icon: 'award-line',
        noCLosable: true,
      },
    }, {
      path: 'scoreDetail',
      name: 'ScoreDetail',
      component: () => import('@/views/game/scoreDetail'),
      meta: {
        title: '积分明细',
        icon: 'article-line',
        noCLosable: true,
      },
    }],
  },
  // 财务
  {
    path: '/finance',
    name: 'Finance',
    component: Layout,
    redirect: '/finance/income',
    // hidden: true,
    meta: {
      title: '财务',
      icon: 'money-cny-circle-line',
    },
    children: [{
      path: 'income',
      name: 'Income',
      component: () => import('@/views/finance/income'),
      meta: {
        title: '线上收款明细',
        icon: 'money-euro-circle-line',
        noCLosable: true,
      },
    }, {
      path: 'refund',
      name: 'Refund',
      component: () => import('@/views/finance/refund'),
      meta: {
        title: '线上退款明细',
        icon: 'money-euro-circle-line',
        noCLosable: true,
      },
    }],
  },
  // 商城
  {
    path: '/shop',
    name: 'Shop',
    component: Layout,
    redirect: '/shop/product',
    hidden: true,
    meta: {
      title: '商城',
      icon: 'shopping-bag-3-line',
    },
    children: [{
      path: 'product',
      name: 'Product',
      component: () => import('@/views/widget/shop/product'),
      meta: {
        title: '商城',
        icon: 'shopping-bag-line',
        noCLosable: true,
      },
    }, {
      path: 'tag',
      name: 'Tag',
      component: () => import('@/views/widget/shop/tag'),
      meta: {
        title: '商品标签',
        icon: 'price-tag-3-line',
        noCLosable: true,
      },
    }, {
      path: 'shopCarousel',
      name: 'ShopCarousel',
      component: () => import('@/views/widget/shop/carousel'),
      meta: {
        title: '轮播图',
        icon: 'image-2-fill',
        noCLosable: true,
      },
    }],
  },
  {
    path: '/display',
    name: 'Display',
    component: Layout,
    redirect: '/display/wechatQrCode',
    meta: {
      title: '展示',
      icon: 'landscape-line',
    },
    hidden: true,
    children: [
      {
        path: 'wechatQrCode',
        name: 'WechatQrCode',
        component: () => import('@/views/widget/wechatQrCode'),
        meta: {
          title: '微信小程序码',
          icon: 'qr-code-line',
          noCLosable: true,
          type: 'wechatCode',
          classify: 'display'
        },
      },
      {
        path: 'carousel',
        name: 'Carousel',
        component: () => import('@/views/widget/carousel'),
        meta: {
          title: '轮播图',
          icon: 'image-2-fill',
          noCLosable: true,
          type: 'carousel',
          classify: 'display'
        },
      },
      {
        path: 'banner',
        name: 'Banner',
        component: () => import('@/views/widget/banner'),
        meta: {
          title: '横幅',
          icon: 'image-line',
          noCLosable: true,
          type: 'banner',
          classify: 'display'
        },
      },
      {
        path: 'article',
        name: 'Article',
        component: () => import('@/views/widget/article'),
        meta: {
          title: '文章',
          icon: 'file-word-line',
          noCLosable: true,
          type: 'article',
          classify: 'display'
        },
      },
    ],
  },
  // 公寓
  {
    path: '/apartment',
    name: 'Apartment',
    component: Layout,
    redirect: '/apartment/apartmentOrder',
    meta: {
      title: '公寓',
      icon: 'home-4-line',
    },
    hidden: true,
    children: [
      {
        path: 'apartmentOrder',
        name: 'ApartmentOrder',
        component: () => import('@/views/order/apartment'),
        meta: {
          title: '订单',
          icon: 'hotel-line',
          noCLosable: true,
        },
      },
      {
        path: 'building',
        name: 'Building',
        component: () => import('@/views/apartment/building'),
        meta: {
          title: '公寓',
          icon: 'hotel-line',
          noCLosable: true,
        },
      },
      {
        path: 'room',
        name: 'Room',
        component: () => import('@/views/apartment/room'),
        meta: {
          title: '房型',
          icon: 'hotel-bed-line',
          noCLosable: true,
        },
      },
      {
        path: 'dynamic',
        name: 'Dynamic',
        component: () => import('@/views/apartment/dynamic'),
        meta: {
          title: '动态',
          icon: 'chrome-line',
          noCLosable: true,
        },
      },{
        path: 'setup',
        name: 'Setup',
        component: () => import('@/views/apartment/setup'),
        meta: {
          title: '配置',
          icon: 'settings-4-line',
          noCLosable: true,
        },
      },
    ],
  },
  {
    path: '/stay',
    name: 'Stay',
    component: Layout,
    redirect: '/record',
    meta: {
      title: '入住',
      icon: 'record-circle-line',
    },
    hidden: true,
    children: [{
      path: 'record',
      name: 'Record',
      component: () => import('@/views/stay/record'),
      meta: {
        title: '入住记录',
        icon: 'calendar-check-line',
        noCLosable: true,
      },
    },
    {
      path: 'receiver',
      name: 'Receiver',
      component: () => import('@/views/stay/receiver'),
      meta: {
        title: '接收人',
        icon: 'image-line',
        noCLosable: true,
      },
    },
    ],
  },
  {
    path: '/customer',
    name: 'Customer',
    component: Layout,
    redirect: '/chat',
    meta: {
      title: '客服',
      icon: 'customer-service-line',
    },
    hidden: true,
    children: [{
      path: 'chat',
      name: 'Chat',
      component: () => import('@/views/customer/chat'),
      meta: {
        title: '会话',
        icon: 'chat-1-line',
        noCLosable: true,
      },
    },
    {
      path: 'servicePeople',
      name: 'ServicePeople',
      component: () => import('@/views/customer/people'),
      meta: {
        title: '客服人员',
        icon: 'customer-service-2-line',
        noCLosable: true,
      },
    },
    ],
  },
  {
    path: '/operation',
    name: 'Operation',
    component: Layout,
    redirect: '/person',
    meta: {
      title: '运维',
      icon: 'tools-line',
    },
    hidden: true,
    children: [{
      path: 'person',
      name: 'Person',
      component: () => import('@/views/operation/person'),
      meta: {
        title: '运维人员',
        icon: 'user-settings-line',
        noCLosable: true,
      },
    },
    {
      path: 'log',
      name: 'Log',
      component: () => import('@/views/operation/log'),
      meta: {
        title: '操作日志',
        icon: 'list-settings-line',
        noCLosable: true,
      },
    },
    ],
  },
  {
    path: '/order',
    name: 'Order',
    component: Layout,
    redirect: '/list',
    meta: {
      title: '订单',
      icon: 'file-list-line',
    },
    hidden: true,
    children: [{
      path: 'list',
      name: 'List',
      component: () => import('@/views/order/list'),
      meta: {
        title: '所有订单',
        icon: 'list-check-2',
        noCLosable: true,
        type: 'all',
        classify: 'order'
      },
    },
    {
      path: 'products',
      name: 'Products',
      component: () => import('@/views/order/products'),
      meta: {
        title: '商品订单',
        icon: 'luggage-cart-line',
        noCLosable: true,
        type: 'products',
        classify: 'order'
      },
    },
    ],
  },
  {
    path: '/notification',
    name: 'Notification',
    component: Layout,
    redirect: '/message',
    meta: {
      title: '通知',
      icon: 'notification-line',
    },
    hidden: true,
    children: [{
      path: 'message',
      name: 'Message',
      component: () => import('@/views/notification/message'),
      meta: {
        title: '短信发送记录',
        icon: 'message-3-line',
        noCLosable: true,
      },
    },
    ],
  },
  {
    path: '/questionRegForm',
    name: 'QuestionRegForm',
    component: Layout,
    redirect: '/index',
    meta: {
      title: '问卷表',
      icon: 'file-list-3-line',
      isHide: true
    },
    hidden: true,
    children: [{
      path: 'index',
      name: 'QuestionRegFormIndex',
      component: () => import('@/views/widget/questionRegForm'),
      meta: {
        title: '问卷表',
        icon: 'article-line',
        noCLosable: true,
        collapse: true,
      },
    },]
  },
  {
    path: '/people',
    name: 'People',
    component: Layout,
    redirect: '/people/index',
    hidden: true,
    meta: {
      title: '用户',
      icon: 'user-3-line',
    },
    children: [{
      path: 'index',
      name: 'PeopleIndex',
      component: () => import('@/views/people/people/index'),
      meta: {
        title: '首页',
        icon: 'file-search-line',
        noCLosable: true,
        collapse: true,
      },
    },],
  },
  {
    path: '/model',
    name: 'Model',
    component: Layout,
    redirect: '/model/index',
    hidden: true,
    meta: {
      title: 'model',
      icon: 'user-3-line',
    },
    children: [{
      path: 'index',
      name: 'index',
      component: () => import('@/views/modelSetting/index'),
      meta: {
        title: 'index',
        icon: 'file-search-line',
        noCLosable: true,
        collapse: true,
      },
    },
    {
      path: 'model',
      name: 'Model',
      component: () => import('@/views/modelSetting/model/index'),
      meta: {
        title: 'model',
        icon: 'file-search-line',
        noCLosable: true,
        collapse: true,
      },
    },{
      path: 'modelInstance',
      name: 'ModelInstance',
      component: () => import('@/views/modelSetting/modelInstance/index'),
      meta: {
        title: 'model实例',
        icon: 'hotel-bed-line',
        noCLosable: true
      },
    },],
  },
]

const router = createRouter({
  history: isHashRouterMode ?
    createWebHashHistory(publicPath) :
    createWebHistory(publicPath),
  routes: constantRoutes,
})

function addRouter(routes) {
  routes.forEach((route) => {
    if (!router.hasRoute(route.name)) router.addRoute(route)
    if (route.children) addRouter(route.children)
  })
}

export function resetRouter(routes = constantRoutes) {
  const names = getNames(routes)
  router.getRoutes().forEach((route) => {
    if (!names.includes(route.name)) router.removeRoute(route.name)
  })
  addRouter(routes)
}

export function setupRouter(app) {
  app.use(router)
  return router
}

export default router
